import { IRequest } from '../types/IRequest';
import { IServer } from '../types/IServer';

export class Request<TParams, TResult> implements IRequest<TParams, TResult> {

  public method: string;
  public params: TParams;

  constructor(method: string, params: TParams) {
    this.method = method;
    this.params = params;
  }

  // This is not used anywhere. It's only purpose is to use TResult so that Result doesn't lose type safety
  // Later versions of TypeScript might not need this. 
  public send(server: IServer): ng.IPromise<TResult> {
    return server.sendRequest<TParams, TResult>(this);
  }

}
